import type { NextPage } from 'next'
import { Product } from '@/client/modules/Product'
import { ProductProps } from '@/client/modules/Product/types'
import { IPaths } from '@/client/types'
import { fetchJson, getDynamicCMSContent } from '@/client/utils'
const CMSApi = process.env.NEXT_PUBLIC_API_CMS

const ProductPage: NextPage<ProductProps> = (props) => <Product {...props} />

export async function getStaticPaths({ locales }) {
  const paths: IPaths[] = []

  console.log('NEXT_PUBLIC_API_CMS =', CMSApi)
  locales.map((locale) => {
    console.log(`${CMSApi}/products?per_page=100&lang=${locale}`)
  })
  const allData = await Promise.all(
    locales.map((locale) => fetchJson(`${CMSApi}/products?per_page=100&lang=${locale}`))
  )

  allData.forEach((arr, index) => {
    arr.forEach(({ slug }) => paths.push({ params: { id: slug }, locale: locales[index] }))
  })

  return {
    paths,
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params: { id }, locale }) {
  const data = (await getDynamicCMSContent(locale, 'products', id)) ?? undefined

  if (!data.content) {
    return {
      notFound: true
    }
  }

  return {
    revalidate: 86400,
    props: { ...data }
  }
}

export default ProductPage
